<div class="bg-secondary">
    <main>
        <div class="container">
           <p>&nbsp;</p>
            <!--Grid row-->
            <div class="row1">
                <b-card>
                    <b-form-group label-cols-lg="3" label="Location Selector" label-size="lg"
                        label-class="font-weight-bold pt-0" class="mb-0">
                        <b-form-group label="Select Location to buy for:" label-for="nested-street" label-cols-sm="12"
                            label-align-sm="left">
                            <b-form-select v-model="selectedLocation">
                                <b-form-select-option v-for="item in locations" :value="item" :key='item'>{{item}}
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group>
                            <base-button class="btn-3" @click="proceed" type="primary">Proceed</base-button>
                        </b-form-group>
                    </b-form-group>
                </b-card>
            </div>
            <!--Grid row-->
            <p>&nbsp;</p>
        </div>
    </main>
    <!--Main layout-->
</div>